module.exports = __webpack_public_path__ + "img/message-2.dbfc3040.png";